import { jsx as _jsx } from "react/jsx-runtime";
import { ImageSlider as GeminiImageSlider, } from "@gemini/ui";
import { ImageFilledIcon } from "@gemini/icons";
import { ImageFallback } from "@/components/UI/Carousel/addons";
import { useI18n } from "@/contexts/i18n";
export const ImageSlider = ({ images, a11yLabel }) => {
    const { t } = useI18n();
    const hasNoImages = !images || (images === null || images === void 0 ? void 0 : images.length) === 0;
    if (hasNoImages) {
        return (_jsx(ImageFallback, { variant: "preview", title: t("gallery.image.fallback.no_photo_message"), description: t("gallery.image.fallback.contact_message"), icon: ImageFilledIcon }));
    }
    return (_jsx(GeminiImageSlider, { images: images, ratio: "4/3", accessibilityLabel: a11yLabel, isSwipeable: true, indicatorOffset: "32" }));
};
